import React from "react";
import ContentItemBlock from "../blocks/SchoolBlocks/ContentItemBlock/ContentItemBlock";
import {
    IReactiveCourseWorkContentItem,
    IReactiveNewsContentItem,
    ReactiveContentItem,
    SchoolFeedContentItem,
} from "../../stores/SchoolFeedStore";
import {observer} from "mobx-react";
import WatsonApi from "../../backends/WatsonApi";
import NotificationManager from "../notifications/NotificationManager";
import {SocialItemModalNavigationProps} from "../modals/SocialItemModal";
import {StoneMason} from "./packery/StoneMason";
import {columnWidth} from "../../utils/SchoolBlocksUtilities";
import {useStores} from "../../stores/useStores";

type ContentItemGridProps = {
    contentItems: SchoolFeedContentItem[] | IReactiveNewsContentItem[] | IReactiveCourseWorkContentItem[] | ReactiveContentItem[]
    handleDeleteContentItem?: (c: ContentItem) => void
} & Omit<SocialItemModalNavigationProps, "initialItemIndex">

const ContentItemGrid = observer((props: ContentItemGridProps) => {
    const {interfaceStore} = useStores();

    async function unpublishItem(item: SchoolFeedContentItem) {
        try {
            const client = await WatsonApi();
            const result = await client.apis.organizations.organizations_content_items_partial_update({
                id: item.id,
                organization_pk: item.organization_id,
                data: {"user_published": !item.published},
            });
            item.update(result.obj);
        } catch (e) {
            NotificationManager.error("Error updating content item");
        }
    }

    return (
        <StoneMason
            useCSSTransforms={false}
            cols={interfaceStore.breakpoint === "break-point-lg" ? 2 : 1}
            maxRows={Infinity}
            rowHeight={200}
            width={columnWidth * 4}
            margin={[14, 14]}
        >
            {props.contentItems.map((item, idx) => {
                return <ContentItemBlock
                    key={item.id}
                    contentItem={item}
                    handleDelete={props.handleDeleteContentItem}
                    unpublishItem={unpublishItem}
                    getItemAtIndex={props.getItemAtIndex}
                    initialItemIndex={idx}
                    totalItemCount={props.totalItemCount}
                    w={1}
                    h={1}
                />
            })}
        </StoneMason>
    )
})

export default ContentItemGrid;
